import { ArrowRight, Mail } from "lucide-react";
import type React from "react";
import { Link } from "react-router-dom";

interface LegacyRouteNoticeProps {
  eyebrow: string;
  title: string;
  description: string;
  showContact?: boolean;
}

const LegacyRouteNotice: React.FC<LegacyRouteNoticeProps> = ({
  eyebrow,
  title,
  description,
  showContact = false,
}) => (
  <section className="site-shell flex min-h-[68vh] items-center py-16">
    <div className="w-full rounded-[2rem] bg-[#4b2e83] px-6 py-14 text-white shadow-2xl sm:px-12 lg:px-20">
      <p className="eyebrow text-emerald-300">{eyebrow}</p>
      <h1 className="mt-4 max-w-4xl text-4xl font-black tracking-tight sm:text-6xl">
        {title}
      </h1>
      <p className="mt-6 max-w-3xl text-lg leading-8 text-violet-100">
        {description}
      </p>
      <div className="mt-9 flex flex-wrap gap-4">
        <Link
          className="inline-flex items-center gap-2 rounded-full bg-emerald-400 px-6 py-3 font-extrabold text-slate-950 transition hover:bg-emerald-300"
          to="/recommendations"
        >
          Browse current resources
          <ArrowRight size={18} aria-hidden="true" />
        </Link>
        {showContact ? (
          <a
            className="inline-flex items-center gap-2 rounded-full border border-violet-300/50 px-6 py-3 font-extrabold text-white transition hover:bg-violet-900"
            href="mailto:armlwacoach@gmail.com"
          >
            Contact the WARML coaches
            <Mail size={18} aria-hidden="true" />
          </a>
        ) : (
          <Link
            className="inline-flex items-center gap-2 rounded-full border border-violet-300/50 px-6 py-3 font-extrabold text-white transition hover:bg-violet-900"
            to="/"
          >
            Return to Washington ARML
            <ArrowRight size={18} aria-hidden="true" />
          </Link>
        )}
      </div>
    </div>
  </section>
);

export default LegacyRouteNotice;
